<app-loader></app-loader>
<div class="container-fluid m-0 p-0 h-100">
  <!--Pre-logIn-->
  <div
    class="row m-0"
    [ngClass]="{
      layout:
        !isIdentityVerificationHandoff &&
        (headerStyle !== 'auth' || isLandingPage),
      'layout-auth':
        !isIdentityVerificationHandoff &&
        headerStyle === 'auth' &&
        !isLandingPage,
      'identity-verification-layout': isIdentityVerificationHandoff
    }"
  >
    <!-- If not auth module -->
    <app-header
      class="layout-header"
      *ngIf="
        !isIdentityVerificationHandoff &&
        headerStyle !== 'auth' &&
        !isLandingPage
      "
    ></app-header>
    <!-- If auth module -->
    <app-sidebar
      class="auth-sidebar"
      *ngIf="
        !isIdentityVerificationHandoff &&
        headerStyle === 'auth' &&
        !isLandingPage
      "
    ></app-sidebar>

    <!-- Content -->
    <section
      [ngClass]="{
        'auth-content':
          !isIdentityVerificationHandoff &&
          headerStyle === 'auth' &&
          !isLandingPage,
        'layout-content':
          !isIdentityVerificationHandoff &&
          (headerStyle !== 'auth' || isLandingPage),
        'identity-verification-content': isIdentityVerificationHandoff
      }"
    >
      <router-outlet></router-outlet>
    </section>

    <!-- If not auth module -->
    <app-post-footer
      class="layout-footer"
      *ngIf="
        !isIdentityVerificationHandoff &&
        headerStyle !== 'auth' &&
        !isLandingPage
      "
    ></app-post-footer>
    <!-- If auth module -->
    <app-footer
      class="auth-footer"
      *ngIf="
        !isIdentityVerificationHandoff &&
        headerStyle === 'auth' &&
        !isLandingPage
      "
    ></app-footer>
  </div>
</div>

<app-help-bot *ngIf="!isIdentityVerificationHandoff"></app-help-bot>
